// All imagery lives here so it can be swapped easily.
export const LOGO = {
  web: "/brand/gu-logo-512.png",
  hero: "/brand/gu-medallion-hero.png",
  pdfCover: "/brand/gu-medallion-pdf.png",
};

export const IMAGES = {
  welcomeHero: "/brand/welcome-hero.jpg",
  journeys: {
    womb: "/brand/journey-womb.jpg",
    spirit: "/brand/journey-spirit.jpg",
    reality: "/brand/journey-reality.jpg",
    lifestyle: "/brand/journey-lifestyle.jpg",
  },
};
